import { render, staticRenderFns } from "./rptfasaldo.vue?vue&type=template&id=490b0bb8&scoped=true"
import script from "./rptfasaldo.vue?vue&type=script&lang=js"
export * from "./rptfasaldo.vue?vue&type=script&lang=js"
import style0 from "./rptfasaldo.vue?vue&type=style&index=0&id=490b0bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b0bb8",
  null
  
)

export default component.exports